import React from 'react';
import PropTypes from 'prop-types';
import { AlertDialog, Callout, Flex, Text } from '@homeexchange/design';
import i18n from '../../../i18n';

const DeleteConfirmDialog = ({ isOpen, onConfirm, onBack, error, isLoading }) => (
    <AlertDialog
        title={i18n.t('collection:modal.applicationCollection.applicationResumeSure.title')}
        confirmActionText={i18n.t('collection:global.confirmApplication')}
        dismissActionText={i18n.t('collection:global.resumeApplication')}
        confirmActionTheme="destructive"
        isOpen={isOpen}
        onConfirmAction={onConfirm}
        onDismissAction={onBack}
        isLoading={isLoading}
    >
        <Flex direction="column">
            <Callout hasIcon status="warning">
                {i18n.t('collection:modal.applicationCollection.applicationResumeSure.calloutBody')}
            </Callout>

            {error && (
                <Flex style={{ marginTop: 12 }}>
                    <Callout hasIcon status="error" size="small">
                        <Text isBold>{i18n.t('common:modal.error-occured.title')}</Text>
                        <Text>{i18n.t('common:modal.error-occured.content')}</Text>
                    </Callout>
                </Flex>
            )}
        </Flex>
    </AlertDialog>
);

DeleteConfirmDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    error: PropTypes.any,
    isLoading: PropTypes.bool
};

DeleteConfirmDialog.defaultProps = {
    error: null,
    isLoading: false
};

export default DeleteConfirmDialog;
